import { render } from "./ConversationList.vue?vue&type=template&id=5aa07085&scoped=true"
import script from "./ConversationList.vue?vue&type=script&lang=js"
export * from "./ConversationList.vue?vue&type=script&lang=js"

import "./ConversationList.vue?vue&type=style&index=0&id=5aa07085&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa07085"]])

export default __exports__